module.exports = __webpack_public_path__ + "img/aadf106.png";